/*
  Pause Rituals — gentle scroll reveal

  Adds .is-in to any [data-reveal] element the first time it is ~20% on screen.
  The CSS decides what "revealed" looks like; this file only flips the class.

  The hidden "before" state only applies once this script has put
  .pr-reveal-ready on <html>. So if the script never runs, nothing is hidden.
  It does not add that class (everything simply shows) when:
    - the visitor prefers reduced motion
    - the page is open in the Shopify theme editor
    - IntersectionObserver is not supported

  Safe to load more than once; re-scans when a section reloads in the editor.
*/
(function () {
  if (window.__prReveal) { window.__prReveal(document); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  var io = null;

  if (!reduce && !editor && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('pr-reveal-ready');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  }
  window.__prReveal = scan;

  scan(document);
  document.addEventListener('DOMContentLoaded', function () { scan(document); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
